"use client"

import dynamic from "next/dynamic"

const ResidencyMap = dynamic(
  () => import("@/components/ResidencyMap").then((mod) => ({ default: mod.ResidencyMap })),
  {
    ssr: false,
    loading: () => (
      <div className="w-full h-[calc(100vh-200px)] min-h-[500px] rounded-xl bg-[var(--muted)] flex items-center justify-center">
        <div className="text-sm text-[var(--muted-foreground)]">Loading map...</div>
      </div>
    ),
  }
)

type MapResidency = {
  id: string
  name: string
  slug: string
  location: string
  country: string
  latitude: number | null
  longitude: number | null
  costType: string
  disciplines: string
  imageUrl: string | null
  googlePlaceId: string | null
  reviews: { rating: number }[]
  archivePollScore?: number | null
  archivePollVotes?: number | null
}

export function ResidencyMapWrapper({ residencies }: { residencies: MapResidency[] }) {
  return <ResidencyMap residencies={residencies} />
}
